import axios from 'axios'
import {alertController, modalController} from '@ionic/vue'
import SecurityErrorModal from '@/components/SecurityErrorModal.vue'
import {ERR_ACCOUNT_IS_LOCKED} from '@/consts/error-message'
import {getCapacitorCookies} from "@/helpers/cookie";
import {datadogLogs} from "@datadog/browser-logs";

const axioService = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    'App-Id': import.meta.env.VITE_APP_ID,
    'Content-Type': 'application/json',
  },
  withCredentials: true,
  timeout: 8000,
})

axioService.interceptors.request.use(
  async config => {
    const cookies = await getCapacitorCookies();
    if (cookies.token) {
      config.headers.Authorization = `Bearer ${cookies.token}`
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axioService.interceptors.response.use(
  async res => {
    if (res.status) {
      return Promise.resolve(res.data)
    }

    const alert = await alertController.create({
      header: 'エラー',
      message: res.data.message || 'エラーが発生しました。もう一度やり直してください。',
      buttons: ['閉じる'],
    })

    await alert.present()
  },
  async err => {
    if (!err.response) {
      datadogLogs.logger.error(err);
      return Promise.reject(err)
    }

    // カスタムヘッダーが存在する場合は401エラーの特別処理をスキップ
    if (err.response.status === 401 && err.config && err.config.headers['X-Skip-401-Interceptor'] === 'true') {
      return Promise.reject(err)
    }

    // 401 だけ特別に処理
    if (err.response.status === 401) {
      const alert = await alertController.create({
        header: 'ログインしていません。',
        buttons: ['閉じる'],
      })
      await alert.present()
      return Promise.reject(err)
    }

    let errorMessage = ''

    if (err.response.status === 422) {
      errorMessage = err.response.data.message || '入力内容をご確認ください。'
    }

    if (err.response.status === 500) {
      errorMessage = err.response.data.message || 'エラーが発生しました。もう一度やり直してください。'
    }

    // 403 は 404 と同じように処理する（アクセス先が存在することを検知させない、サーバからも 404 を返すべき）
    if (err.response.status === 403 || err.response.status === 404) {
      // FIXME: この文言どうすべきか要検討
      if (err.response.data.message === 'USER_SUSPENDED') {
        const modal = await modalController.create({
          component: SecurityErrorModal,
          backdropDismiss: false,
          cssClass: 'security-error-modal',
        })
        modal.present()
        return Promise.reject(err)
      }
      errorMessage = err.response.data.message || '見つかりません。'
    }

    if (err.response.status === 400) {
      // FIXME: この文言どうすべきか要検討、これも 422 と同じでよい気がする
      errorMessage = err.response.data.message || '不正なリクエスト。'
    }

    // アカウントロックエラーの時だけUIが変わるため、分岐
    if (errorMessage !== ERR_ACCOUNT_IS_LOCKED) {
      const alert = await alertController.create({
        header: 'エラー',
        message: errorMessage,
        buttons: ['閉じる'],
      })

      await alert.present()
    }

    return Promise.reject(err)
  }
)

export default axioService